import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { TripPathArrow } from '../Icons/TripActionsIcon'
const useStyles = makeStyles((theme) => ({
  info: {
    padding: 24,
    backgroundColor: '#161f34',
    height: '100%',
    minHeight: 84,
    maxHeight: 84,
    borderRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    display: 'flex',
    flexDirection: 'row',
    color: '#ffffff',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  path: {
    width: 70,
    color: '#fff',
    backgroundColor: '#FFF',
    margin: '24px 8px'
  },
  location: {
    fontSize: 16,
    fontWeight: 300
  },
  date: {
    opacity: 0.8,
    fontSize: 12
  },
  connectDiv: {

  },
  connecter: {
    color: '#fff'
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&.before': {
      content: '',
      flex: 1,
      borderBottom: '1px solid #000'
    },
    '&.after': {
      content: '',
      flex: 1,
      borderBottom: '1px solid #000'
    }
  },
  autoMargin: {
    //marginLeft:'auto'
  }
}));
const RouteInfo = (props) => {
  const { location, defaultSelected, destination, source, startDate, completedDate } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultSelected ? defaultSelected : 0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={classes.info}>
      <div>
        <Typography className={classes.location}>
          {source ? source : ''}
        </Typography>
        <Typography className={classes.date}>
          {startDate ? startDate : ''}
        </Typography>
      </div>

      {/* <div className={classes.autoMargin}><hr className={classes.path} /></div> */}
      <div className={classes.autoMargin}>
        <TripPathArrow className={classes.connecter} />
      </div>
      {/* <div className={classes.autoMargin}><hr className={classes.path} /></div> */}


      {/* <div className={classes.separator}>Next section</div> */}


      <div className={classes.autoMargin}>
        <Typography className={classes.location}>
          {destination ? destination : ''}
        </Typography>
        <Typography className={classes.date}>
          {completedDate ? completedDate : ''}
        </Typography>
      </div>
    </div>
  );
}
const RouteInfoWithRouter = withRouter(RouteInfo);
export default RouteInfoWithRouter;